// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Qr2","selected":"styles_selected__I3YHm"};